// extracted by mini-css-extract-plugin
export default {"container":"container__RegulatoryActivityViewer__J8Ovv","mainContentContainer":"mainContentContainer__RegulatoryActivityViewer__J8Ovv"};